import { render } from "./Card.vue?vue&type=template&id=d2edd926&scoped=true"
const script = {}

import "./Card.vue?vue&type=style&index=0&id=d2edd926&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2edd926"]])

export default __exports__